import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Aspect } from '@xanadu/model';
import { PickerComponent } from '../picker/picker.component';
import { AspectCache } from '@xanadu/cache';

@Component({
    selector: 'app-aspect-picker',
    templateUrl: './aspect-picker.component.html',
    styleUrls: ['./aspect-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AspectPickerComponent extends PickerComponent<Aspect> {
    private readonly aspectCache = inject(AspectCache);

    constructor() {
        super();
        effect(() => {
            const aspects = this.aspectCache.signal();

            if (aspects) {
                this.items.set([...aspects.values()]);
            }
        });
    }

    protected filter(aspect: Aspect): boolean {
        return true;
    }
}
